export const baseFldsDescriptionListTier1 = [
  {
    name: 'email',
    type: 'email',
    tier: 1,
    i18n: 'email',
    required: true,
    step: 1
  },
  {
    name: 'login',
    type: 'login',
    tier: 1,
    i18n: 'login',
    required: true,
    step: 1
  },
  {
    name: 'password',
    type: 'passwordFields',
    tier: 1,
    required: true,
    step: 1
  },
  {
    name: 'privacyPolicy',
    type: 'privacyPolicy',
    tier: 1,
    required: true,
    step: 1
  }
]

export const baseFldsDescriptionListTier2 = [
  {
    name: 'firstName',
    type: 'text',
    tier: 2,
    i18n: 'firstName',
    required: true,
    step: 1
  },
  {
    name: 'lastName',
    type: 'text',
    tier: 2,
    i18n: 'lastName',
    required: true,
    step: 1
  },
  {
    name: 'citizenshipCountry',
    type: 'country',
    tier: 2,
    i18n: 'citizenshipCountry',
    required: true,
    step: 1
  },
  {
    name: 'residenceCountry',
    type: 'country',
    tier: 2,
    i18n: 'residenceCountry',
    required: true,
    step: 1
  },
  {
    name: 'faceImage',
    type: 'faceImage',
    tier: 2,
    i18n: 'faceImage',
    required: true,
    step: 1
  },
  {
    name: 'idScan',
    type: 'idScan',
    tier: 2,
    i18n: 'documents',
    required: true,
    step: 1
  }
]
